import { truncate } from "../helpers";
import PanelController from "./panel-controller";

export default class extends PanelController {
  static targets = ["content"];
  static values = { productId: "string", key: "string" };

  async initialize() {
    this.productId = null;
    this.url = `https://ejs-reviews.onrender.com/reviews?key=${this.keyValue}&product=${this.productIdValue}`;

    if (this.productIdValue) {
      const reviews = (await this.fetchReviews()) ?? [];

      if (reviews.length > 0) {
        this.buildReviews(reviews);
      }
    }

    // Get reviews-open query param
    const urlParams = new URLSearchParams(window.location.search);
    const reviewsOpen = urlParams.get("reviews-open");

    if (reviewsOpen) {
      this.togglePanel();
      // Remove reviews-open query param and update URL without refresh
      urlParams.delete("reviews-open");
      const newUrl = window.location.pathname + "?" + urlParams.toString();
      window.history.replaceState({}, "", newUrl);
    }
  }

  async fetchReviews() {
    try {
      const res = await fetch(this.url);
      if (res.ok) {
        const data = await res.json();
        return data.response?.reviews || [];
      } else {
        console.error("There was an error", res);
      }
    } catch (error) {
      console.error("There was an error", error);
    }
  }

  renderStars(score) {
    let scoreMarkup = "";
    for (let i = 0; i < score; i++) {
      const diff = score - i;

      if (diff >= 1) {
        scoreMarkup += `<span class="product-review__star"></span>`;
      } else if (diff > 0) {
        scoreMarkup += `<span class="product-review__star product-review__star--half"></span>`;
      }
    }

    for (let i = 0; i < 5 - score; i++) {
      const diff = score - i;

      if (diff > 0) {
        scoreMarkup += `<span class="product-review__star product-review__star--empty"></span>`;
      }
    }

    return scoreMarkup;
  }

  buildReviews(reviews) {
    this.contentTarget.innerHTML = reviews
      .map((review) => {
        const {
          title,
          user,
          verified_buyer,
          score,
          created_at,
          content,
          id,
          comment,
          images_data,
        } = review;

        return `
        <div class="product-review">
          <p class="product-review__user">
            ${user.display_name}
            ${verified_buyer ? "<span>(verified buyer)</span>" : ""}
          </p>
          <div class="product-review__meta">
            <div class="product-review__stars product-review__stars--white">
              ${this.renderStars(score)}
            </div>
            <p class="product-review__date">
              ${new Date(created_at).toLocaleDateString("en-GB")}
            </p>
          </div>
          <div class="product-review__head">
            <h3 class="product-review__title">${title}</h3>
          </div>
          <p>
            ${truncate({ string: content, refId: id })}
          </p>

          ${
            comment
              ? `
              <div class="product-review__response">
                <input type="checkbox" id="response-${comment.id}" />
                <label class="product-review__response-toggle" for="response-${comment.id}">
                  <span>Show</span><span>Hide</span> Response
                </label>
                <p class="product-review__response-content">
                  ${comment.content}
                </p>
              </div>
            `
              : ``
          }
          ${
            images_data
              ? `
                <div class="product-review__image">
                  <input type="checkbox" id="product-review-image-${id}" />
                  <label
                    class="product-review__image-toggle" for="product-review-image-${id}"
                    for="${id}"
                  >
                    <span>Show</span><span>Hide</span> Image
                  </label>
                  <img class="product-review__image-item" src="${images_data[0].original_url}" alt="${title}" />
                </div>
                `
              : ""
          }
        </div>
      `;
      })
      .join("");
  }
}
